import { Checkbox, CheckboxProps } from '@whoop/web-components';
import React from 'react';
import styles from './index.module.scss';

const DarkmodeCheckbox = ({ ...props }: CheckboxProps) => (
  <Checkbox {...props} className={styles.root} />
);

export default DarkmodeCheckbox;
